import LocalizedStrings from 'localized-strings';

export const locales = new LocalizedStrings({
  en: {
    categories: {
      1: {
        details: '(71% allowance)',
        title: 'Sales of goods, catering and accommodation (BIC)',
        url: "https://mycompanyinfrance.urssaf.fr/documentation/entreprise/chiffre-d'affaires/vente-restauration-h%C3%A9bergement",
      },
      2: {
        details: '(50% allowance)',
        title: 'Supply of commercial or craft services (BIC)',
        url: "https://mycompanyinfrance.urssaf.fr/documentation/entreprise/chiffre-d'affaires/service-BIC",
      },
      3: {
        details: '(34% allowance)',
        title: 'Other services and self-employed activities (BNC)',
        url: "https://mycompanyinfrance.urssaf.fr/documentation/entreprise/chiffre-d'affaires/service-BNC",
      },
      title:
        'There are three categories with different lump-sum expense allowance rates:',
    },
    conclude:
      'If your company has activities corresponding to multiple income categories, answer yes to this question.',
    example:
      'For example, a plumbing company invoicing for the purchase and installation of a faucet has part of its turnover in the sale of materials (the faucet) and part in the provision of services (the installation).',
    subtitle:
      'It is possible for the same business to have different types of income.',
    title: 'Mixed activities',
  },
  fr: {
    categories: {
      1: {
        details: '(abattement de 71%)',
        title: 'Ventes de biens, restauration et hébergement (BIC)',
        url: "https://mon-entreprise.urssaf.fr/documentation/entreprise/chiffre-d'affaires/vente-restauration-h%C3%A9bergement",
      },
      2: {
        details: '(abattement de 50%)',
        title: 'Prestation de service commerciale ou artisanale (BIC)',
        url: "https://mon-entreprise.urssaf.fr/documentation/entreprise/chiffre-d'affaires/service-BIC",
      },
      3: {
        details: '(abattement de 34%)',
        title: 'Autres prestation de service et activité libérale (BNC)',
        url: "https://mon-entreprise.urssaf.fr/documentation/entreprise/chiffre-d'affaires/service-BNC",
      },
      title:
        'Il existe trois catégories avec des taux d’abattement forfaitaire pour frais différents :',
    },
    conclude:
      'Si votre entreprise a des activités correspondants à plusieurs catégories de revenus, répondez oui à cette question.',
    example:
      "Par exemple, une entreprise de plomberie qui facture l'achat et la pose d'un robinet a une partie de son chiffre d'affaires en vente de matériel (le robinet) et une partie en prestation de service (la pose).",
    subtitle:
      "Il est possible d'avoir des activités avec des types de revenus différents pour une même entreprise.",
    title: 'Activités mixtes',
  },
} as const);
